import React, { useContext, useState } from 'react'
import { useChannelWithNormalGifFetch } from 'shared/api/channels'
import AddFeaturedGifOverlay from 'shared/components/add-featured-gif-overaly'
import ChannelPageContext from 'shared/components/context/channel-page'
import GridTypeContext from 'shared/components/context/grid-type'
import Grid from 'shared/components/grid'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import { grid9 } from 'shared/util/grid'
import { getAllTheCopy } from 'shared/util/string'
import styled from 'styled-components'
import Feed from '../feed'
import Navigation from './navigation'
import NoResults from './no-results'

const Container = styled.div`
    margin-top: 30px;
`

type Props = {
    isOwner?: boolean
    onNoResultsUpdate?: (noResults: boolean) => void
}

const ChannelGrid = ({ isOwner, onNoResultsUpdate }: Props) => {
    const { channel, channelType, searchQuery } = useContext(ChannelPageContext)
    const [noResults, showNoResults] = useState<boolean | undefined>(undefined)
    const { id, display_name: displayName, has_children: hasChildren, content_type: contentType } = channel
    const { gridType } = useContext(GridTypeContext)
    const isFeaturedTag = channelType === 'tagged_channel'
    let fetchOptions
    if (channelType === 'tagged_channel' || channelType === 'search_channel') {
        fetchOptions = { term: searchQuery, isFeaturedTag }
    }
    const fetchGifs = useChannelWithNormalGifFetch(id, 'gifs', fetchOptions)
    // fetches are cached in memory so no need to worry about the extra fetch
    const testForGifs = useChannelWithNormalGifFetch(id, 'gifs', fetchOptions)
    useAsyncEffect(async () => {
        const result = await testForGifs(0)
        showNoResults(result.data.length === 0)
        onNoResultsUpdate && onNoResultsUpdate(result.data.length === 0)
    }, [])
    const title = searchQuery || isFeaturedTag || !hasChildren ? '' : getAllTheCopy(displayName, contentType)
    if (noResults === undefined) {
        return null
    }
    return (
        <Container>
            <Navigation title={title} noResults={noResults} />
            {gridType === 'feed' ? (
                <Feed fetchGifs={fetchGifs} />
            ) : (
                <Grid Overlay={AddFeaturedGifOverlay} fetchGifs={fetchGifs} width={grid9} />
            )}
            {noResults && <NoResults isOwner={isOwner} />}
        </Container>
    )
}

export default ChannelGrid
